export const resolvedConfig = {};
